import { assign } from 'fsm';
import Raven from 'raven-js';
import { fetchSmartProperty, getEmptyPropertiesCount, runSmartFill } from './client';
import { wait } from '../../../utils';
export const machine = {
  initial: 'loadSmartProperty',
  states: {
    loadingRecordsWithEmptyProperties: {
      invoke: {
        src: 'getEmptyPropertiesCount',
        onDone: {
          target: 'idle',
          actions: ['setTotalWithEmptyPropertiesCount']
        },
        onError: {
          target: 'idle',
          actions: ['logError']
        }
      },
      tags: ['loading']
    },
    loadSmartProperty: {
      invoke: {
        src: 'fetchSmartProperty',
        onDone: [{
          cond: 'isQuerySelectionMethod',
          target: 'loadingRecordsWithEmptyProperties',
          actions: ['setSmartProperty']
        }, {
          target: 'idle',
          actions: ['setSmartProperty']
        }],
        onError: {
          target: 'idle',
          actions: ['logError']
        }
      },
      tags: ['loading']
    },
    enrichedProperties: {
      invoke: {
        src: 'wait',
        onDone: {
          target: 'idle',
          actions: ['closeDrawerAfterEnriched']
        }
      }
    },
    enriching: {
      invoke: {
        src: 'runSmartFill',
        onDone: {
          target: 'enrichedProperties',
          actions: ['startAIProcessing', 'addEnrichSuccess']
        },
        onError: {
          target: 'errorEnrichment',
          actions: ['setErrorId', 'addEnrichError', 'logError']
        }
      }
    },
    errorEnrichment: {
      on: {
        ENRICH: 'enriching'
      },
      tags: ['error']
    },
    idle: {
      on: {
        SET_FILL_OPTIONS: {
          target: 'idle',
          actions: ['setFillOptions']
        },
        ENRICH: 'enriching'
      }
    }
  },
  actions: {
    addEnrichError: context => {
      context.onError(context.errorId);
    },
    addEnrichSuccess: context => {
      context.onSuccess(context.selectedProperties.length);
    },
    closeDrawerAfterEnriched: context => {
      context.onClose();
    },
    logError: (_, event) => {
      const {
        responseJSON
      } = event.data;
      Raven.captureException(responseJSON);
    },
    setErrorId: assign((_context, event) => {
      const {
        responseJSON = {}
      } = event.data;
      const {
        correlationId
      } = responseJSON;
      return {
        errorId: correlationId
      };
    }),
    setFillOptions: assign((_, event) => {
      return {
        fillOption: event.data.fillOption
      };
    }),
    setSmartProperty: assign((_, event) => {
      return {
        smartProperty: event.data
      };
    }),
    setTotalWithEmptyPropertiesCount: assign((_context, event) => {
      return {
        totalWithEmptyProperties: event.data
      };
    }),
    startAIProcessing: context => {
      const {
        objectTypeId,
        onEnrich,
        propertyName,
        selectionIds
      } = context;
      const selectedObjectTypeId = objectTypeId;
      if (onEnrich) {
        onEnrich === null || onEnrich === void 0 || onEnrich(selectedObjectTypeId, propertyName, selectionIds);
      }
    }
  },
  guards: {
    isQuerySelectionMethod: context => {
      return context.selectionMethod === 'BY_QUERY';
    }
  },
  services: {
    fetchSmartProperty,
    runSmartFill,
    wait: () => wait(),
    getEmptyPropertiesCount
  }
};